var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionRetryRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09814 3.19995C5.17938 3.19995 1.99951 6.32531 1.99951 10.1843C1.9996 14.0429 5.17952 17.1677 9.09814 17.1677H10.3071C10.5277 17.1675 10.7063 16.9889 10.7065 16.7683C10.7065 16.5476 10.5278 16.3682 10.3071 16.3679H9.09814C5.61837 16.3679 2.80038 13.5979 2.80029 10.1843C2.80029 6.77022 5.61824 3.99976 9.09814 3.99976H9.30322L9.62744 4.00854C12.7651 4.16459 15.294 6.57424 15.5747 9.61987L14.2603 8.6228C14.0427 8.45769 13.7321 8.50002 13.5669 8.71753C13.4018 8.93501 13.4442 9.24569 13.6616 9.41089L15.7632 11.0056C15.9807 11.1706 16.2904 11.1283 16.4556 10.9109L18.0513 8.8103C18.2164 8.59277 18.1741 8.2821 17.9565 8.11694C17.739 7.95184 17.4284 7.99514 17.2632 8.21265L16.3569 9.40601C15.9735 6.00248 13.1063 3.33898 9.58057 3.20581C9.55816 3.20192 9.53475 3.19995 9.51123 3.19995H9.09814Z",
    fill: "#20016B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionRetryRedo);
export default __webpack_public_path__ + "static/media/action-retry-redo.1591e3e1e8b19c667bbb13b9b69278df.svg";
export { ForwardRef as ReactComponent };